import type { RouteObject } from 'react-router-dom';
import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import { NotFoundPage } from '@/pages/not-found';
import { LoginPage } from '@/pages/login';
import { OAuthCallbackPage } from '@/pages/oauth-callback';

import { StorageOverviewPage } from '@/pages/dashboard/storage-overview';
import { TransportOverviewPage } from '@/pages/dashboard/transport-overview';
import { ServiceUsersPage } from '@/pages/dashboard/service-users';
import { MappingPage } from '@/pages/dashboard/mapping';
import { ConsignmentsPage } from '@/pages/consignments';
import { ConsignmentEditPage } from '@/pages/consignment-edit';

import { PrivateLayout } from '@/widgets/private-layout';
import { PublicLayout } from '@/widgets/public-layout';

import { RouteNames } from '@/shared/config/routes';
import { AuthGuard } from '@/shared/lib';
import { ProjectSiteRedirect, ProjectSiteLoader } from '@/features/routing';

export const publicRoutes: RouteObject[] = [
  {
    element: (
      <AuthGuard requireAuth={false}>
        <PublicLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: RouteNames.LOGIN,
        element: <LoginPage />
      },
      {
        element: <OAuthCallbackPage />,
        children: [
          {
            path: RouteNames.AZURE_CALLBACK
          },
          {
            path: RouteNames.CIAM_CALLBACK
          }
        ]
      },
      {
        path: RouteNames.NOT_FOUND,
        element: <NotFoundPage />
      }
    ]
  }
];

export const privateRoutes: RouteObject[] = [
  {
    element: (
      <AuthGuard requireAuth={true}>
        <PrivateLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: RouteNames.HOME,
        element: <ProjectSiteRedirect />
      },
      {
        path: RouteNames.CONSIGNMENTS,
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ConsignmentsPage />
          </Suspense>
        )
      },
      {
        path: RouteNames.CONSIGNMENT_EDIT,
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ConsignmentEditPage />
          </Suspense>
        )
      },
      {
        path: RouteNames.PROJECT_SITE_HOME,
        element: <ProjectSiteLoader />,
        children: [
          {
            index: true,
            element: <Navigate to="dashboard/storage-overview" replace />
          },
          {
            path: 'dashboard/storage-overview',
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <StorageOverviewPage />
              </Suspense>
            )
          },
          {
            path: 'dashboard/transport-overview',
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <TransportOverviewPage />
              </Suspense>
            )
          },
          {
            path: 'dashboard/service-users',
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ServiceUsersPage />
              </Suspense>
            )
          },
          {
            path: 'dashboard/mapping',
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <MappingPage />
              </Suspense>
            )
          },
          {
            path: 'requests',
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ConsignmentsPage />
              </Suspense>
            )
          }
        ]
      }
    ]
  }
];
